import ChallengeCountdown from "@/challenges/ChallengeCountdown";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import {
  container,
  heading,
  headingWrapper,
  subHeading,
  subHeadingWrapper,
} from "./ChallengeLandingHeader.style";

interface ChallengeLandingHeaderProps {
  expirationDate?: Date | null | undefined;
}

const ChallengeLandingHeader = ({
  expirationDate,
}: ChallengeLandingHeaderProps) => {
  const { isTeacher } = useGetUserProperties();
  const now = new Date();
  const expiration = expirationDate || now;
  const month = expiration.toLocaleString("en-GB", { month: "short" });
  const date = expiration.getDate();
  const countdown = Math.floor(
    (expiration.getTime() - now.getTime()) / (1000 * 3600 * 24),
  );
  const todayMonth = now.toLocaleString("en-GB", { month: "long" });
  return (
    <div css={container}>
      <div css={headingWrapper}>
        <h2 css={heading}>
          {todayMonth.charAt(0).toUpperCase() + todayMonth.slice(1)} reading
          challenge
        </h2>
      </div>
      {!isTeacher && (
        <div css={subHeadingWrapper}>
          <p css={subHeading(true)}>1. Find content</p>
          <p css={subHeading(true)}>2. Complete activities</p>
          <p css={subHeading(false)}>3. Earn tokens</p>
        </div>
      )}
      <ChallengeCountdown month={month} date={date} countdown={countdown} />
    </div>
  );
};

export default ChallengeLandingHeader;
